"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondSection = void 0;
const react_1 = __importStar(require("react"));
const SecondSection_elements_1 = require("./SecondSection.elements");
const articulation_svg_1 = __importDefault(require("@components/icons/landing/articulation.svg"));
const sounds_svg_1 = __importDefault(require("@components/icons/landing/sounds.svg"));
const motor_svg_1 = __importDefault(require("@components/icons/landing/motor.svg"));
const line_up_svg_1 = __importDefault(require("@components/icons/landing/line-up.svg"));
const gesture_svg_1 = __importDefault(require("@components/icons/landing/gesture.svg"));
const speech_cloud_svg_1 = __importDefault(require("@components/icons/landing/speech-cloud.svg"));
const Feature_1 = require("../Feature");
const components_1 = require("@app/routes/Landing/components/MainLanding/components");
const Landing_1 = require("@app/routes/Landing");
const SecondSection_translations_1 = require("./SecondSection.translations");
const SecondSection = ({}) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = SecondSection_translations_1.translations[language];
    const [videoPopUp, setVideoPopUp] = (0, react_1.useState)(null);
    const [infoPopUp, setInfoPopUp] = (0, react_1.useState)(null);
    const closePopUp = () => setInfoPopUp(null);
    const openPopUp = (message) => setInfoPopUp({ message: message });
    return (react_1.default.createElement(SecondSection_elements_1.SecondSectionWrap, null,
        react_1.default.createElement("h1", null, t.h1),
        react_1.default.createElement("div", { className: "landing-second-section-content" },
            react_1.default.createElement("div", { className: "landing-second-section-row" },
                react_1.default.createElement(Feature_1.Feature, { className: "landing-second-section-articulation", icon: react_1.default.createElement(articulation_svg_1.default, null), title: t.features["1"].title, text: t.features["1"].text, href: "/list_exercise?group=articulation", slug: "articulation", openVideo: (title, url, video) => setVideoPopUp({
                        title: title,
                        url: url,
                        video: video,
                    }) }),
                react_1.default.createElement(Feature_1.Feature, { className: "landing-second-section-sounds", icon: react_1.default.createElement(sounds_svg_1.default, null), title: t.features["2"].title, text: t.features["2"].text, href: "/list_exercise?group=sound", slug: "sounds", openVideo: (title, url, video) => setVideoPopUp({
                        title: title,
                        url: url,
                        video: video,
                    }) })),
            react_1.default.createElement("div", { className: "landing-second-section-row" },
                react_1.default.createElement(Feature_1.Feature, { className: "landing-second-section-motor", icon: react_1.default.createElement(motor_svg_1.default, null), title: t.features["3"].title, text: t.features["3"].text, href: "/list_exercise?group=motor", slug: "motor", openVideo: (title, url, video) => setVideoPopUp({
                        title: title,
                        url: url,
                        video: video,
                    }) }),
                react_1.default.createElement(Feature_1.Feature, { className: "landing-second-section-speech", icon: react_1.default.createElement(line_up_svg_1.default, null), title: t.features["4"].title, text: t.features["4"].text, href: "/list_exercise?group=speech", slug: 'speech', openVideo: (title, url, video) => setVideoPopUp({
                        title: title,
                        url: url,
                        video: video,
                    }) })),
            react_1.default.createElement("div", { className: "landing-second-section-row" },
                react_1.default.createElement(Feature_1.Feature, { className: "landing-second-section-plan", icon: react_1.default.createElement(gesture_svg_1.default, null), title: t.features["5"].title, text: t.features["5"].text, href: "/profile?q=ipoc", onlyRu: true, onlyPatient: true, onUnfoldClick: () => openPopUp(t.features["5"].popUpMessage), openVideo: (title, url, video) => setVideoPopUp({
                        title: title,
                        url: url,
                        video: "https://d9fvxjfzq4088.cloudfront.net/demos/personal-plan.mp4",
                    }), signUpRequired: true }),
                react_1.default.createElement(Feature_1.Feature, { className: "landing-second-section-monitor", icon: react_1.default.createElement(speech_cloud_svg_1.default, null), title: t.features["6"].title, href: "/profile?q=dashboard", signUpRequired: true, onlyPatient: true, onUnfoldClick: () => openPopUp(t.features["6"].popUpMessage) }))),
        videoPopUp && (react_1.default.createElement(components_1.VideoPopUp, { title: videoPopUp.title, url: videoPopUp.url, video: videoPopUp.video, onClose: () => setVideoPopUp(null) })),
        infoPopUp && (react_1.default.createElement(components_1.InfoPopUp, { onClose: closePopUp }, infoPopUp.message))));
};
exports.SecondSection = SecondSection;
